// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"63952ed7","372":"9a4d7e0b","496":"59cd71f2","738":"f9fd6491","856":"ca0c5ac0","858":"385ad0ca"}[chunkId] + ".chunk.js";
};